import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../services";
import { IngredientsServices } from '../../../ingredients/services';
import { Globals } from '../../../../globals';
import { getCurrencySymbol } from '@angular/common';
import { StaticsServices } from '../../../services/statics';
import { ArticleViewPage } from '../../../articles/articles-view/article-view';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { AIServices } from '../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the DishCreatePricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-create-price',
  templateUrl: 'dish-create-price.html',
})
export class DishCreatePricePage {

  price: number = 0;
  price_half: number = 0;
  price_tapa: number = 0;
  price_supplement: number = 0;
  price_combo_extra: number = 0;
  price_takeaway: number = 0;
  update_state: boolean = false;
  dish_uid: string;
  dish_name: string;
  _currency: any;
  dish: any;
  dish_tax: number = this.globals.RESTAURANT_TAX;
  ean: string = "";
  loaderAI: boolean = false;
  suggestedPrice: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public dishServices: DishServices,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public staticsServices: StaticsServices,
    private analyticsServices: AnalyticsServices,
    public aiServices: AIServices) {

    this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update');
    this.dish_name = this.navParams.get('dish_name');
    this.dish = this.navParams.get('dish') || {};

    if (this.dish && this.dish.tax != undefined) {
      this.dish_tax = this.dish.tax;
    }
    if (this.dish && !this.dish.type_unit) {
      this.dish.type_unit = 'ud';
    }
    if (this.update_state) {
      this.price = this.navParams.get('price');
      this.price_half = this.navParams.get('price_half');
      this.price_tapa = this.navParams.get('price_tapa');
      this.price_supplement = this.navParams.get('price_supplement');
      this.price_combo_extra = this.navParams.get('price_combo_extra');
      this.price_takeaway = this.navParams.get('price_takeaway');
      this.ean = this.navParams.get('ean');
    } else {
      this.price = 0;
      this.price_half = 0;
      this.price_tapa = 0;
      this.price_supplement = 0;
      this.price_combo_extra = 0;
      this.price_takeaway = 0;
      this.ean = "";
    }

    this._currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');


  }

  ionViewWillLeave() {
    this.ingredientsServices.quick_create = false;
    this.ingredientsServices.quick_create_dish = false;
    this.ingredientsServices.quick_create_type = false;
  }

  update() {
    if (this.price == undefined || this.price == null) {
      this.price = 0;
    }
    if (this.price_half == undefined || this.price_half == null) {
      this.price_half = 0;
    }
    if (this.price_tapa == undefined || this.price_tapa == null) {
      this.price_tapa = 0;
    }
    if (this.price_supplement == undefined || this.price_supplement == null) {
      this.price_supplement = 0;
    }
    if (this.price_combo_extra == undefined || this.price_combo_extra == null) {
      this.price_combo_extra = 0;
    }
    if (this.price_takeaway == undefined || this.price_takeaway == null) {
      this.price_takeaway = 0;
    }
    if (this.ean == undefined || this.ean == null) {
      this.ean = "";
    }
    if (!this.update_state) {
      this.price_takeaway = this.price;
    }
    this.sendData();

    this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
      'price': this.price,
      'price_half': this.price_half,
      'price_tapa': this.price_tapa,
      'price_supplement': this.price_supplement,
      'price_combo_extra': this.price_combo_extra,
      'price_takeaway': this.price_takeaway,
      'tax': this.dish_tax,
      'ean': this.ean,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      if (this.dishServices.quick_create) {
        this.dishServices.quick_create = false;
        if (this.dishServices.quick_create_type) {
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
        } else {
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
        }
      } else {
        this.analyticsServices.trackingExpArticles('update dish', this.globals.tracking_exp['update_article'], this.dish_uid);
        if (this.update_state) {
          this.globals.GAtrackView('Dish', 'Dish - Price - Update', this.globals.restaurant.email, 'Create/Update', 'Update price', 'Dish', this.dish_name);
          this.staticsServices.changeStateStaticWait(true);
          this.navCtrl.pop();
        } else {
          this.globals.tourLaunchStep(9);
          this.globals.GAtrackView('Dish', 'Dish - Price - Create', this.globals.restaurant.email, 'Create/Update', 'Create price', 'Dish', this.dish_name);
          //Go to finish proces
          this.navCtrl.push(ArticleViewPage, {
            article_type: 'dish',
            article_uid: this.dish_uid
          });
        }
      }

    });
  }

  sendData() {
    this.globals.dataSet('plat_price', this.price, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_price_half', this.price_half, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_price_tapa', this.price_tapa, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_price_supplement', this.price_supplement, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_price_combo_extra', this.price_combo_extra, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_price_takeaway', this.price_takeaway, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_tax', this.dish_tax, '', this.dish_name);//Send dish data
    this.globals.dataSet('plat_ean', this.ean, '', this.dish_name);//Send dish data
  }

  inputPrice() {
    if (this.globals.so_mobile) {
      let cssClasses = {
        'input-group': true,
        'w-110': true,
        'w-150': false
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'input-group': true,
        'w-150': true,
        'w-110': false
      }
      return cssClasses;
    }
  }

  changeSalesType(value) {
    this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
      'type_unit': value,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    });
    this.dish.type_unit = value;
  }

  profitFoodCost(price, _foodcost, _parts, _type) {
    var foodcost = (_foodcost / _parts) * _type
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }

  async getSuggestedPrice() {
    if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
      this.loaderAI = true;
      this.suggestedPrice = 0;
      var restaurant = "restaurante";
      var location = this.globals.restaurant.address;
      //prepare restaurante type and cuisine
      if (this.globals.restaurant.business) {
        restaurant = this.globals.getBusinessType(this.globals.restaurant.business);
      } else if (this.globals.restaurant.business2) {
        restaurant = this.globals.getBusinessType(this.globals.restaurant.business2);
      }
      if (this.globals.restaurant.cuisine) {
        restaurant += " " + this.globals.getCuisineType(this.globals.restaurant.cuisine);
      } else {
        restaurant += " " + this.globals.getCuisineType(this.globals.restaurant.cuisine2);
      }
      //prepare location
      if (this.globals.restaurant.address_state) {
        location = this.globals.restaurant.address_state + ", " + this.globals.restaurant.address_province + ", " + this.globals.restaurant.address_country;
      }
      //prepare params for ai services
      var timeout = 30000;
      var response_format = { type: "json_object" };

      var prompt_es = "¿Qué precio medio tiene " + this.globals.nameLangSelectDish(this.dish) + " (" + this.globals.descriptionLangSelectArticle(this.dish) + ") para un " + restaurant + " en " + location + "? Entrega únicamente el precio medio como valor numérico, sin unidades ni texto adicional, y en formato JSON. Utiliza el formato: { \"suggested_price\": [precio_sugerido] }.";
      var messages = [
        {
          role: "system",
          content: "You are an expert AI assistant that provides accurate and concise information."
        },
        {
          role: "user",
          content: `Primero, traduce el siguiente texto del español al inglés, y luego responde al texto traducido en inglés, ayúdate buscando en internet e intenta que la información sea la más actual: '${prompt_es}'`
        }
      ];

      //call ai service function
      const response = await this.aiServices.openAIGenerateSuggestedPrice(response_format, messages, timeout);
      // convertimos el json text a json
      var AiResponse = response['choices'][0].message.content;
      var json_Response = JSON.parse(AiResponse);
      this.loaderAI = false;
      this.suggestedPrice = parseFloat(json_Response.suggested_price);
      //send slack
      var title = "AI SUGGESTED PRICE ARTICLE";
      var section = {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": ":hotel: " + this.globals.restaurant.company +
            "\n :email: " + this.globals.restaurant.email +
            "\n :knife_fork_plate: " + this.globals.nameLangSelectDish(this.dish) +
            "\n :keyboard: " + prompt_es +
            "\n :credit_card: " + AiResponse + "\n"
        }
      };
      this.globals.sendCustomerMctSlack(title, section);
    }
    else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-price/dish-create-price.ts